<template>
    <div class="content1">
        <h1>{{ translation["STR_LIVE_SYSSTATUS"] }}</h1>
        <span v-html="translation['STR_LIVE_SYSSTATUS1']"></span><br/><br/>
        <table>
            <thead>
                <th width="500">Service Name</th>
                <th width="180">Live Status</th>
            </thead>
            <tbody>
                <tr v-for="s in services">
                    <td> {{ s.name }}</td>
                    <td :class="s.statecode"> {{ s.state }}</td>
                </tr>
                <tr v-if="!services.length">
                    <td>Daten werden geladen...</td>
                </tr>
            </tbody>
        </table>
        <br/>
        {{ translation["STR_MORE_DETAILS" ] }}<br/>
        https://status.poc.procomcure.com/
    </div>
</template>
<script>
export default ({
    props: [ 'token', 'translation' ],
    data() {
        return {
            services: [],
        }
    },
    mounted() {
        this.axios.get("/api/uptime?token="+this.token)
        .then((r) => {
            r.data.monitors.forEach((m) => {
                switch(m.state) {
                    case "up":
                        var status = "Operational";
                    break;
                    case "down":
                        var status = "Degraded";
                    break;
                }
                this.services.push({
                    name: m.name,
                    state: status,
                    statecode: m.state,
                });
            })
        })
    }
})
</script>
<style scoped>
.up {
    background-color: lightgreen;
    text-align: center;
}

.down {
    background-color: pink;
    text-align: center;
}
table tr:nth-child(even) {
    background-color: rgba(220,220,220,0.9);
}
</style>